import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';

const PrescriptionStatusShimmer = () => {
  return (
    <Card className="h-100 shadow-sm border overflow-hidden">
      <style>{`
        @keyframes shimmer {
          0% { background-position: -600px 0; }
          100% { background-position: 600px 0; }
        }
        .shimmer-box {
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 800px 100%;
          animation: shimmer 1.4s infinite linear;
          border-radius: 6px;
        }
      `}</style>

      {/* Header */}
      <Card.Header className="d-flex align-items-center justify-content-between flex-wrap gap-2 pb-2">
        <div className="shimmer-box" style={{ width: '140px', height: '20px' }} />

        <div className="d-flex align-items-center gap-2">
          <div className="shimmer-box" style={{ width: '180px', height: '36px' }} />
          <div className="shimmer-box" style={{ width: '130px', height: '36px', borderRadius: '4px' }} />
        </div>
      </Card.Header>

      <Card.Body className="pt-2">
        <Row className="align-items-center justify-content-between g-3">
          {/* Left Column: 5 distribution lines shimmer */}
          <Col xs={12} sm={7} md={7}>
            <div className="d-flex flex-column justify-content-center pe-sm-2 gap-2 py-1">
              {[1, 2, 3, 4, 5].map(idx => (
                <div key={idx} className="d-flex align-items-center justify-content-between py-1">
                  <div className="d-flex align-items-center gap-2">
                    <div className="shimmer-box rounded-circle flex-shrink-0" style={{ width: '8px', height: '8px' }} />
                    <div className="shimmer-box" style={{ width: idx === 1 ? '70px' : '130px', height: '12px' }} />
                  </div>
                  <div className="shimmer-box" style={{ width: '60px', height: '12px' }} />
                </div>
              ))}
            </div>
          </Col>

          {/* Right Column: Donut Chart Shimmer */}
          <Col xs={12} sm={5} md={5} className="d-flex justify-content-center align-items-center">
            <div style={{ position: 'relative', width: '8.5rem', height: '8.5rem' }}>
              <div
                style={{
                  width: '100%',
                  height: '100%',
                  borderRadius: '50%',
                  background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
                  backgroundSize: '800px 100%',
                  animation: 'shimmer 1.4s infinite linear'
                }}
              />
              <div
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  width: '70%',
                  height: '70%',
                  borderRadius: '50%',
                  backgroundColor: '#fff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <div className="shimmer-box" style={{ width: '40px', height: '16px' }} />
              </div>
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default PrescriptionStatusShimmer;